<div class="change-email-modal-container">
  <!-- Loading state -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p>Loading DP details...</p>
  </div>

  <!-- Main content (when not loading) -->
  <div *ngIf="!isLoading">
    <!-- Modal header -->
    <div class="modal-header">
      <h5 class="modal-title">
        <i class="fa fa-envelope"></i> Change Email for Designated Person
      </h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
    </div>

    <!-- Modal body -->
    <div class="modal-body">
      <!-- Error message -->
      <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
        <i class="fa fa-exclamation-circle"></i>
        {{ errorMessage }}
      </div>

      <!-- Step 1: Email Input -->
      <div *ngIf="step === 'input'" class="step-input">
        <div class="form-group mb-3">
          <label class="form-label">
            <strong>DP Name</strong>
          </label>
          <input
            type="text"
            class="form-control"
            [value]="dpFullData?.dpName || '-'"
            disabled
          />
        </div>

        <div class="form-group mb-3">
          <label class="form-label">
            <strong>Designation</strong>
          </label>
          <input
            type="text"
            class="form-control"
            [value]="dpFullData?.dpDesignation || '-'"
            disabled
          />
        </div>

        <div class="form-group mb-3">
          <label for="currentEmail" class="form-label">
            <strong>Current Email (Read-Only)</strong>
          </label>
          <input
            type="email"
            class="form-control"
            id="currentEmail"
            [value]="currentEmailFull"
            disabled
            placeholder="Loading..."
          />
          <small class="form-text text-muted">This email will be marked as inactive</small>
        </div>

        <div class="form-group mb-3">
          <label for="newEmail" class="form-label">
            <strong>New Email Address</strong>
          </label>
          <input
            type="email"
            class="form-control"
            id="newEmail"
            [(ngModel)]="newEmail"
            (ngModelChange)="onNewEmailChange()"
            (blur)="onNewEmailBlur()"
            placeholder="Enter new email (e.g., jane.doe@company.com)"
            [class.is-invalid]="shouldShowValidationError() && validationError !== ''"
          />
          <small class="form-text text-muted">
            Enter only the email address. If needed, duplicate handling suffix is added automatically by the system.
          </small>
          <div *ngIf="shouldShowValidationError() && validationError" class="invalid-feedback d-block">
            <i class="fa fa-times-circle"></i> {{ validationError }}
          </div>
        </div>
      </div>

      <!-- Step 2: Confirmation -->
      <div *ngIf="step === 'confirmation'" class="step-confirmation">
        <div class="confirmation-box">
          <h6 class="mb-3">
            <i class="fa fa-check-circle text-success"></i> Please Confirm Email Change
          </h6>

          <div class="confirmation-detail mb-3">
            <p class="mb-1"><strong>DP Name:</strong></p>
            <div class="email-display">
              {{ dpFullData?.dpName || '-' }}
            </div>
          </div>

          <div class="confirmation-detail mb-3">
            <p class="mb-1"><strong>Designation:</strong></p>
            <div class="email-display">
              {{ dpFullData?.dpDesignation || '-' }}
            </div>
          </div>

          <div class="confirmation-detail mb-3">
            <p class="mb-1"><strong>Current Email (will be deactivated):</strong></p>
            <div class="email-display">
              {{ currentEmailFull }}
            </div>
          </div>

          <div class="arrow-down text-center mb-3">
            <i class="fa fa-arrow-down"></i>
          </div>

          <div class="confirmation-detail mb-3">
            <p class="mb-1"><strong>New Email (will be activated):</strong></p>
            <div class="email-display new-email">
              {{ newEmail }}
            </div>
          </div>

          <div class="alert alert-info mt-3">
            <i class="fa fa-info-circle"></i>
            <strong>What happens:</strong>
            <ul class="mb-0 mt-2">
              <li>Old DP will be marked as <strong>inactive</strong> (soft-deleted)</li>
              <li>New DP will be created with the new email address</li>
              <li>All historical data will be preserved in activity logs</li>
              <li>Both actions will be recorded with reasons for audit trail</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal footer -->
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="step === 'input' ? cancel() : goBackToInput()"
      >
        <i class="fa fa-times"></i> {{ step === 'input' ? 'Cancel' : 'Go Back' }}
      </button>

      <!-- Input step actions -->
      <button
        *ngIf="step === 'input'"
        type="button"
        class="btn btn-primary"
        (click)="proceedToConfirmation()"
        [disabled]="shouldDisableProceed()"
      >
        <i class="fa fa-arrow-right"></i> Validate & Proceed
      </button>

      <!-- Confirmation step actions -->
      <button
        *ngIf="step === 'confirmation'"
        type="button"
        class="btn btn-success"
        (click)="proceedWithEmailChange()"
        [disabled]="isProcessing"
      >
        <span *ngIf="isProcessing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        <i *ngIf="!isProcessing" class="fa fa-check"></i>
        {{ isProcessing ? 'Processing...' : 'Confirm & Change Email' }}
      </button>
    </div>
  </div>
</div>
